'use client';
import { Link, Stack, StackProps, Typography } from '@zeus/core';
import { FormattedMessage } from 'react-intl';
import { BrokenSuitcase } from '../broken-suitcase/BrokenSuitcase';

export interface NonAuthenticatedErrorProps extends StackProps {
  homePageLinkUrl: string;
}

export const NonAuthenticatedError: React.FC<NonAuthenticatedErrorProps> = ({
  homePageLinkUrl,
  ...props
}) => (
  <Stack alignItems="center" {...props}>
    <BrokenSuitcase />
    <Typography variant="h5" color="text.primary">
      <SomethingWentWrong />
    </Typography>
    <Link href={homePageLinkUrl} target="_self" sx={{ mt: 1 }}>
      <Typography variant="body2">
        <ReturnToHome />
      </Typography>
    </Link>
  </Stack>
);

const SomethingWentWrong = () => (
  <FormattedMessage
    id="shared-ui.non-authenticated-error.something-went-wrong"
    defaultMessage="Sorry, something went wrong"
  />
);

const ReturnToHome = () => (
  <FormattedMessage
    id="shared-ui.non-authenticated-error.return-to-home"
    defaultMessage="Return to home"
  />
);
